/* eslint-disable */

import {
    INIT_URL,
    CHECKING_SCREEN_OFF,
    SIGNIN_USER_SUCCESS,
    SIGNOUT_USER_SUCCESS,
    AUTO_SIGNIN_USER_SUCCESS,
    APP_MENUS,
    IS_MENU_FETCHED,
    MENU_SLUG_URL
} from "../ActionTypes/Auth";
import { FETCH_SUCCESS } from "../ActionTypes/index";

import { get, post, setToken, setUser, clearStorage, getUser, getToken } from "./index";
export const setInitUrl = url => {
    return {
        type: INIT_URL,
        payload: url
    };
};

export const login = (userData, history, call_back = () => { }) => {
    return (dispatch) => {
        post(dispatch, '', `user/login`, userData, {}, (data = {}) => {
            if (data.show_otp_input) {
                call_back(data);
            } else if (data.token) {
                setToken(data.token);
                setUser(data.auth);
                dispatch({ type: SIGNIN_USER_SUCCESS, payload: { token: data.token, userData: data.auth } });
            } else {
                call_back(data);
            }
        });
    };
};

export const forgotpassoword = (userData, history, success = () => { }) => {
    return (dispatch) => {
        post(dispatch, '', `user/forgot-password`, userData, {}, (data) => {
            history.replace('/reset-password', { username: userData.username, customer_id: userData?.customer_id || null, otp_type: userData.otp_type, message: data.otp_msg });
            success(data);
        });
    };
};

export const verifyPassword = (userData, history, success = () => { }) => {
    return (dispatch) => {
        post(dispatch, '', `user/verify-password`, userData, {}, (data) => {
            history.replace('/login');
            success(data);
        });
    };
}

export const logout = (history) => {
    return (dispatch) => {
        get(dispatch, '', `user/logout`, {}, (data) => {
            clearStorage(false);
            history.replace('/login');
            dispatch({ type: SIGNOUT_USER_SUCCESS });
        });
    };
};

export const AutoLogin = (token, call_back = () => { }) => {
    return (dispatch) => {
        get(dispatch, '', 'user', { token: token }, (auth) => {
            setUser(auth);
            setToken(token);
            dispatch({ type: AUTO_SIGNIN_USER_SUCCESS, payload: { token: token, userData: auth } });
            dispatch({ type: CHECKING_SCREEN_OFF });
            call_back(true);
        }, () => {
            dispatch({ type: CHECKING_SCREEN_OFF });
            clearStorage(false);
            dispatch({ type: SIGNOUT_USER_SUCCESS });
        });
    };
};

export const SilentLogin = (location, history) => {
    return (dispatch) => {
        const token = getToken();
        if (!token) {
            history.push(`/login${location.search || ''}`);
        }
        dispatch({ type: SIGNIN_USER_SUCCESS, payload: { token: token, userData: getUser() } });
        dispatch({ type: CHECKING_SCREEN_OFF });
    };
};

function getMenuSlugs(data, storage) {
    for (let key in data) {
        const { menu_slug = null, url = "", children = [], menu_version = 2 } = data[key];
        if (menu_slug && url) storage[menu_slug] = url;
        if (children?.length > 0 && menu_version == 1) getMenuSlugs(children, storage);
    }
}

export const getMyMenus = (history, user) => {
    return async (dispatch) => {
        // setting up timeout if get response withing time the okay else make menu is empty Array
        let id = setTimeout(() => {
            id = null;
            dispatch({ type: FETCH_SUCCESS });
        }, 20000);

        get(dispatch, window.env.HRMS_BASE_URL, `auth/user/get_menus/${1}?new_format=1`, {}, (data) => {
            let { menu } = data;
            clearTimeout(id);
            if (Array.isArray(menu) && menu.length && id) {
                const SLUG_WITH_URLS = {};
                Array.isArray(menu) && getMenuSlugs(menu, SLUG_WITH_URLS);
                dispatch({ type: MENU_SLUG_URL, payload: SLUG_WITH_URLS });
                dispatch({ type: APP_MENUS, payload: menu });
                dispatch({ type: IS_MENU_FETCHED, payload: true });
            }
        }, () => {
            dispatch({ type: IS_MENU_FETCHED, payload: true });
        });
    }
}